/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import DTOLoansFinished from "./DTOLoansFinished";
import LoansFinishedPresenter from "./LoansFinishedPresenter";
import { useTranslation } from "react-i18next";
function LoansFinishedController() {
  const currency = useAppSelector((state) => state.authSlice.currency);
  const [allLoansData, setAllLoansData] = useState([]);
  const { t } = useTranslation();
 
  const isLoading = useAppSelector(
    (state) => state.loansHistorySlice.loanHistoryLoader
  );

  function callBackFunc(data: any) {
    setAllLoansData(data);
  }

  return (
    <>
      <DTOLoansFinished setLoansFinishedData={callBackFunc} />
      <LoansFinishedPresenter
        loansData={allLoansData}
        currency={currency}
        isLoading={isLoading}
        trans={t}
      />
    </>
  );
}

export default LoansFinishedController;
